
import { defineComponent, ref, Ref } from "vue";
import { ChangePasswordParams, UserService } from "@/utils/api/user";
import { ElMessage } from 'element-plus';

export default defineComponent({
  props: {
    phoneNumber: String,
  },
  setup(props, context) {
    const information: Ref<ChangePasswordParams> = ref({
      phoneNumber: "",
      newPassword1: "",
      newPassword2: "",
    });
    information.value.phoneNumber = props.phoneNumber as string;
    const form = ref(null);
    const submitForm = () => {
      let flag;
      (form.value as any).validate((valid: boolean) => {
        flag = valid;
        return valid;
      });
      if (flag === true) {
        UserService.changePassword(information.value)
          .then((res) => {
            console.log(res.data);
            if (res.data.a == 18) {
              context.emit("confirmChange");
            } else {
              openError('修改失败，请联系管理员！');
            } 
          })
          .catch((error) => {
            console.log(error);
          });
      }
    };
    const checkNewPassword1 = (rule: any, value: any, callback: any) => {
      if (!value) {
        return callback(new Error("新密码不能为空"));
      }
      let r = /^.{6,15}$/;
      if (!r.test(value)) {
        return callback(new Error('密码应该为6到15个字符'));
      }
      callback();
    };
    const checkNewPassword2 = (rule: any, value: any, callback: any) => {
      if (!value) {
        return callback(new Error("确认密码不能为空"));
      }
      if (information.value.newPassword1 !== '' && information.value.newPassword1 !== value) {
        return callback(new Error('两次密码不相同'));
      }
      callback();
    };
    const rules = {
      newPassword1: [{ validator: checkNewPassword1, trigger: "submit" }],
      newPassword2: [{ validator: checkNewPassword2, trigger: "submit" }],
    };
     const openError= (inf: string) => {
          ElMessage({
            showClose: true,
            message: inf,
            type: 'error',
            offset: 200,
          });
    };  
    return {
      information,
      form,
      submitForm,
      rules,
      openError,
    };
  },
});
